import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Inject, NgModule, Optional, SkipSelf } from '@angular/core';

import { ProductListService } from '@pages/payments/components/transfer/services/product-list.service';

import { AuthService } from '@shared/services/auth.service';
import { DigestService } from '@shared/services/digest.service';
import { GeneralService } from '@shared/services/general.service';

import { SvgSpriteComponent } from './components/svg-sprite/svg-sprite.component';
import { NativePluginModule } from './native-plugin.module';
import { AlertService } from './services/alert/alert.service';
import { ApiUrlService } from './services/api/api-url.service';
import { AppSettingsService } from './services/app-settings/app-settings.service';
import { B2pService } from './services/b2p/b2p.service';
import { BankBikService } from './services/bank-bik/bank-bik.service';
import { ContactService } from './services/contacts/contact.service';
import { CorrInfoService } from './services/corr-info/corr-info.service';
import { DeviceService } from './services/device/device.service';
import { DocumentService } from './services/document/document.service';
import { LoadingService } from './services/loading/loading.service';
import { MobilePaymentService } from './services/mobile-payment/mobile-payment.service';
import { PrintDocumentService } from './services/print/print-document.service';
import { PublicDataService } from './services/public-data/public-data.service';
import { RurService } from './services/rur/rur.service';
import { SbpUtilService } from './services/sbp/sbp-util.service';
import { SbpService } from './services/sbp/sbp.service';
import { ServicePaymentService } from './services/service-payment/service-payment.service';
import { UserDataService } from './services/user-data/user-data.service';

@NgModule({
  declarations: [SvgSpriteComponent],
  providers: [
    AuthService,
    ApiUrlService,
    DigestService,
    DeviceService,
    UserDataService,
    LoadingService,
    AlertService,
    AppSettingsService,
    GeneralService,
    SbpService,
    ContactService,
    ProductListService,
    PublicDataService,
    BankBikService,
    RurService,
    CorrInfoService,
    B2pService,
    MobilePaymentService,
    ServicePaymentService,
    SbpUtilService,
    DocumentService,
    PrintDocumentService
  ],
  exports: [SvgSpriteComponent],
  imports: [CommonModule, HttpClientModule, NativePluginModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() @Inject(CoreModule) parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded');
    }
  }
}
